import { render, staticRenderFns } from "./UiToggle.vue?vue&type=template&id=5106c72d&"
import script from "./UiToggle.vue?vue&type=script&lang=ts&"
export * from "./UiToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports